import { useState } from 'react';
import { NamespaceType } from '@wix/ambassador-devcenter-v1-app/types';

export const useModalState = () => {
  const [isValidated, setIsValidated] = useState<boolean>(false);
  const [isSuggestionsFetched, setIsSuggestionsFetched] =
    useState<boolean>(false);

  const [name, setName] = useState<string | undefined>();
  const [isNameValidating, setIsNameValidating] = useState<boolean>();
  const [nameError, setNameError] = useState<string>();

  const [namespace, setNamespace] = useState<string | undefined>();
  const [isNamespaceValidating, setIsNamespaceValidating] = useState<boolean>();
  const [namespaceError, setNamespaceError] = useState<string>();
  const [namespacePrefixes, setNamespacePrefixes] =
    useState<NamespacePrefixes>();
  const [selectedNamespacePrefixType, setSelectedNamespacePrefixType] =
    useState<NamespaceType>(NamespaceType.COMPANY);

  return {
    isValidated,
    setIsValidated,
    isSuggestionsFetched,
    setIsSuggestionsFetched,
    name,
    setName,
    isNameValidating,
    setIsNameValidating,
    namespace,
    setNamespace,
    namespacePrefixes,
    setNamespacePrefixes,
    isNamespaceValidating,
    setIsNamespaceValidating,
    selectedNamespacePrefixType,
    setSelectedNamespacePrefixType,
    nameError,
    setNameError,
    namespaceError,
    setNamespaceError,
  };
};

export type NamespacePrefixes = { [key in NamespaceType]?: string };
